__turbopack_context__.v({
  "component": "style-module-scss-module__9Kp3Ka__component",
  "grid": "style-module-scss-module__9Kp3Ka__grid",
  "header": "style-module-scss-module__9Kp3Ka__header",
  "less": "style-module-scss-module__9Kp3Ka__less",
  "login-cta": "style-module-scss-module__9Kp3Ka__login-cta",
  "sign-in": "style-module-scss-module__9Kp3Ka__sign-in",
  "view-more": "style-module-scss-module__9Kp3Ka__view-more",
});
